import './FormAbrirChamado.css'
import { IoDocumentText, IoClose } from "react-icons/io5";
import { IoIosAttach } from "react-icons/io";
import { LuImagePlus } from "react-icons/lu";
import CampoObrigatorio from '../CampoObrigatorio/CampoObrigatorio';
import { TicketContext } from '../../context/TicketContext';
import { useContext } from 'react';
import HeaderContainers from '../HeaderContainers/HeaderContainers';
import Loading from '../Loading/Loading';
import Anexo from '../Anexo/Anexo';
import { useTranslation } from 'react-i18next';


function FormAbrirChamado() {

    const { t } = useTranslation();
    const { ticketData, handleChange, handleFileChange, handleFileRemove, loading } = useContext(TicketContext);
    
    const defaultDescricao = `Base: 
CNPJ: 
Período: 
Nome do colaborador (incluir como exemplo; caso a situação ocorra com mais de um, favor informar): 
Problema percebido: 
Resultado esperado: `;

    const mudarAssunto = "assunto";
    const mudarDescricao = "descricao";

    return (
        <div className="criar-novo-ticket-container">
            {loading && <Loading />}
            <HeaderContainers texto={t("abrir-chamado")} />

            <div className="formulario-abrir-novo-chamado">
                <form>
                    <div className="container-input-chamado">
                        <label htmlFor="assunto-chamado">
                        {t("assunto")} <CampoObrigatorio />
                        </label>
                        <input type="text" id='assunto-chamado' name="assunto-chamado" onChange={(e) => {handleChange(mudarAssunto, e.target.value)}} placeholder={t("assunto-tooltip")}/>   
                    </div>

                    <div className="container-input-chamado">
                        <label htmlFor="descricao-chamado">
                            <IoDocumentText className="icon-azul" />
                            {t("descricao-chamado")} <CampoObrigatorio />
                        </label>

                        <textarea
                            onChange={(e) => {handleChange(mudarDescricao, e.target.value)}}
                            id="descricao-chamado"
                            name="descricao-chamado"
                            rows="7"
                            cols="50"
                            placeholder={t("descricao-tooltip")}
                            defaultValue={defaultDescricao}
                        >
                        </textarea>
                    </div>

                    <div className="anexos-e-adicionais-container">
                        <div className="container-selecionar-arquivos">
                            <div className="container-input-chamado">
                                <label className="input-file-label" htmlFor="anexo-chamado">
                                    <IoIosAttach />
                                </label>
                                <input onChange={(e) => {handleFileChange(e, 'attachment')}} type="file" id="anexo-chamado" name="anexo-chamado" style={{ display: 'none' }} />
                            </div>

                            <div className="container-input-chamado">
                                <label className="input-file-label" htmlFor="imagem-chamado">
                                    <LuImagePlus />
                                </label>
                                <input onChange={(e) => {handleFileChange(e, 'imagens')}} type="file" id="imagem-chamado" name="imagem-chamado" style={{ display: 'none' }} />
                            </div>
                        </div>

                        <div className="informacoes-anexos-adicionados">
                            <p className="quantidade-arquivos-adicionados">{ticketData.imagens.length + ticketData.anexos.length}</p>
                            <p className="textos-arquivos-adicionados">{t("qnt-arquivos-adcionados")}</p>
                        </div>
                    </div>
                </form>

                {(ticketData.anexos.length > 0 || ticketData.imagens.length > 0)
                && <AnexosSelecionados
                        anexos={ticketData.anexos}
                        onRemoveAnexo={(index) => handleFileRemove(index, 'anexos')}
                        imagens={[ticketData.imagens]}
                        onRemoveImage={(index) => handleFileRemove(index, 'imagens')}
                    />}

            </div>
        </div>
    )
}

const AnexosSelecionados = ({ anexos, onRemoveAnexo, imagens, onRemoveImage }) => {

    return (
        <div className='container-global-anexos'>
            <p className='escrita-anexos'>ANEXOS</p>
            <hr className='linha-anexos'></hr>
            <div className='container-anexos'>

                {imagens.flat().map((imagem, index) => (
                <div className="container-imagem-selecionada" key={index}>
                    <IoClose className='botao-remover-imagem' onClick={() => onRemoveImage(index)} />
                    <img className="imagem-selecionada-pelo-usuario-chamado" src={imagem.url} alt="Arquivo Selecionado" />
                </div>
                ))}

                {anexos.map((anexo, index) => {
                    return (
                        <div key={index} className="container-anexo-selecionado">
                            <IoClose className='botao-remover-anexo' onClick={() => onRemoveAnexo(index)}/>
                            <div className='container-interno-anexo'>
                                <Anexo
                                    tipoDeArquivo={anexo.file.type}
                                />
                                <div className='informacoes-internas-anexo'>
                                    <p className="nome-anexo-selecionado-pelo-usuario-chamado" title={anexo.file.name}>
                                        {anexo.file.name}
                                    </p>
                                    <p className="texto-tamanho-anexo-selecionado" title={anexo.file.size}>
                                        {(anexo.file.size / 1024).toFixed(2)} 
                                    </p>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default FormAbrirChamado